// frontend/src/components/Common/UI/fields/HtmlField.jsx
import { useRef, useMemo, useState } from 'react';
import { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import JoditEditor from 'jodit-react';

const HtmlField = ({ value, field, onChange, disabled, theme }) => {
  const editorRef = useRef(null);
  const [editorContent, setEditorContent] = useState(value || '');

  useEffect(() => setEditorContent(value || ''), [value]);

  const isDark = theme?.palette?.mode === 'dark' || false;
  // Конфиг Jodit (можно вынести в отдельный файл или сделать динамическим)
  const config = useMemo(
    () => ({
      theme: isDark ? 'dark' : 'default', // ✅ Встроенная dark тема
      readonly: disabled || !field.editable,
      height: field.height || 400, // можно задавать в metadata
      placeholder: field.placeholder || 'Начните вводить HTML-текст...',
      language: 'ru', // или 'en'
      toolbarAdaptive: false,
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      defaultActionOnPaste: 'insert_clear_html',
      buttons:
        'bold,italic,underline,|,ul,ol,|,link,|,align,left,right,center,|,source', // упрощённый тулбар
      // full набор: 'source | undo redo | bold italic underline | align | ul ol | link image table | ...'
      cleanHTML: {
        removeEmptyElements: true,
        fillEmptyParagraph: true,
      },
    }),
    [disabled, field.editable, field.height, isDark],
  );

  const handleSave = () => {
    // Передаём актуальное содержимое наверх
    onChange(field.field, editorContent);
    // Можно добавить уведомление / индикатор сохранения
    console.log('HTML сохранён:', editorContent);
  };

  // ────────────────────────────────────────────────
  // Если disabled — показываем только просмотр
  // ────────────────────────────────────────────────
  if (disabled) {
    return (
      <Box sx={{ mt: 1, width: '100%' }}>
        {/* <Typography variant='subtitle2' gutterBottom>
          {field.label}
        </Typography> */}

        <Box
          sx={{
            p: 2,
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            minHeight: field.height || 200,
            // bgcolor: 'background.paper',
            overflow: 'auto',
            '& img': {
              maxWidth: '100%',
              height: 'auto',
            },
            '& p': { mb: 1.5 },
            '& ul, & ol': { pl: 3, mb: 1.5 },
          }}
          dangerouslySetInnerHTML={{
            __html: value || '<em>Нет содержимого</em>',
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mt: 1,
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      {/* Заголовок + кнопка Сохранить */}
      <Box
        sx={{
          p: 1,
          // bgcolor: 'grey.100',
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='subtitle2'>{field.label}</Typography>

        {!disabled && field.editable && (
          <Button
            variant='contained'
            size='small'
            color='primary'
            startIcon={<SaveIcon />}
            onClick={handleSave}
            // disabled={editorContent === value} // опционально: отключить если не изменилось
          >
            Сохранить
          </Button>
        )}
      </Box>

      <JoditEditor
        ref={editorRef}
        value={editorContent}
        config={config}
        tabIndex={1}
        onBlur={(newContent) => {
          // onBlur — рекомендуемый способ обновления для производительности
          setEditorContent(newContent);
        }}
        onChange={(newContent) => {
          // Можно использовать onChange для live-превью, но лучше только onBlur
          // setEditorContent(newContent); // если хотите live-update (но может быть тяжело)
        }}
      />
    </Box>
  );
};

export default HtmlField;
